import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-abortmultipart',
  templateUrl: './abortmultipart.component.html',
  styleUrls: ['./abortmultipart.component.css']
})
export class AbortmultipartComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }


  requestData = `
  curl -v 'https://api.optimusdrive.ai/vod/v1/customer/multipart/abort' \
  -H 'authorization: XXX' \
  --data-raw '{
    "key_path": "vod/input/bc96e670-4450-9c1-a53c-5175182040e2/1f3dd1eb-e71a-42c9-b1b0-c991fe842239/Show.MOV",
    "upload_id": "teG.HH3cgjd3jWwcg43WxVEffwce0ewmZnPW5y8zEXPaqXRpGGsIahEqVRV.cMoauaWfolPD4bhp4ahXE4Qu1FMSOoAWe5NZP8UC25W3cG7S16ZM14_ML3j_MT9ZAhlkYZaO6zkaZqSDYEJSXJe1elzDU4eYpgEb_1kMpW0"
  }' 

 `

 copyToClipBoard(url: string) {
  var txtArea = document.createElement('textarea');
  txtArea.id = 'txt';
  txtArea.style.position = 'fixed';
  txtArea.style.top = '0';
  txtArea.style.left = '0';
  txtArea.style.opacity = '0';
  txtArea.value = url;
  document.body.appendChild(txtArea);
  txtArea.select();

  try {
    var successful = document.execCommand('copy');
    if (successful) {
     this.copyButton = false;
     this.copiedButton = true;
// After a few seconds, reset the button states
    setTimeout(() => {
      this.copyButton = true;
      this.copiedButton = false;
    }, 1000);
    }
  } catch (err) {
  } finally {
    document.body.removeChild(txtArea);
  }
}

copyJsonToClipboard() {
  this.copyToClipBoard(this.requestData);
}






  sucessData = `
  {
    "data": {
        "RequestCharged": null
    },
    "message": "Aborted upload successfully"
}
  `

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `

  Error4x =`
  {
    "error": "InvalidParameter: 1 validation error(s) found.\n- minimum field size of 1, AbortMultipartUploadInput.Key.\n",
    "message": "Error aborting upload."
  }`

  Error42x =`
  {
    "error": "NoSuchUpload: The specified upload does not exist. The upload ID may be invalid, or the upload may have been aborted or completed.\n\tstatus code: 404, request id: 9JYTGAZ3DTBRHQN0, host id: n0OD/xM9JcYYQO79nIbV5M2PAF4hXtmyjRCLgfKnK2bGpHpbtLblNbtAFxrekwlQOqTbeYpD2aE=",
    "message": "Error aborting upload."
  }


  `



  Error401x=`
  {
    "error": {},
    "message": "Unauthorized"
  }
  `


}
